export default __webpack_public_path__ + "static/media/AvenirNextW10-UltraLight.e45e721b.ttf";